export const STRINGS = {
  APP: {
    CURRENT_CONTEXT: "Current Context",
    SIGN_OUT: "Sign out",
  },
  AUTH: {
    TITLE: "Sign in to Get Started",
    EMAIL_LABEL: "Email",
    EMAIL_PLACEHOLDER: "Enter your email",
    PASSWORD_LABEL: "Password",
    PASSWORD_PLACEHOLDER: "Enter your password",
    SIGN_IN_BUTTON: "Sign In",
    SIGNING_IN_BUTTON: "Signing in...",
    LOGIN_ERROR_FALLBACK: "An error occurred during login.",
    SERVER_DOWN_ERROR: (status: number) => `Server error (${status}): The server might be down.`,
    INVALID_RESPONSE_ERROR: "Received an invalid response from the server.",
    FAILED_TO_LOGIN: "Failed to login",
    SELECT_ORGANIZATION_TITLE: "Select Organization",
    USER_ORGANIZATIONS_NOT_FOUND: "No organizations found for this user.",
    FAILED_TO_FETCH_USER: "Failed to fetch user information.",
  },
  CHAT: {
    DEFAULT_GREETING: "Hello! How can I help you today?",
    INPUT_PLACEHOLDER: "Ask Refly...",
  },
};
